export default class Nav
{
    constructor($el, options = {}) {
        this.DOM = { $el }
        this.options = { ...Nav.prototype.defaults, ...options }
        this.init()
    }

    init() {
        this.DOM.$user = this.DOM.$el.querySelector(this.options.selectorUser)
        this.DOM.$userToggle = this.DOM.$el.querySelector(this.options.selectorUserToggle)

        this.DOM.$tabs = this.DOM.$el.querySelectorAll(this.options.selectorTabs)
        this.DOM.$tabs.forEach(tab => {
            tab.addEventListener('click', this.onTabClick.bind(this))
        });

        if (this.DOM.$userToggle) {
            document.body.addEventListener('click', this.onDocumentClick.bind(this))
        }
    }

    onDocumentClick(e) {
        if (!e.target.closest(this.options.selectorUser)) {
            this.DOM.$userToggle.checked = false
        }
    }

    onTabClick(e) {
        if (!e.currentTarget.classList.contains(this.options.itemIsActive)) {
            return;
        }

        e.preventDefault()
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }
}

Nav.prototype.defaults = {
    selectorUser: '.js-navUser',
    selectorUserToggle: '.js-navUserToggle',
    selectorTabs: '.js-navtab',
    itemIsActive: 'is-active'
}